
	jQuery(document).ready(function(){

        //-----------------------------------------------------------------------
        // Política privacidad formularios
        //-----------------------------------------------------------------------
        var jQuerymodal = jQuery('#veissModal'),
            politicaInput = '#privacidad input',
            politicaSpan = '#privacidad span',
            privacidad = jQuery(politicaInput).prop('checked');
    
        /**
         * 1. La política no está aceptada: mostrar modal.
         * 2. La política ya está aceptada: desmarcar.
         */
        jQuery(document).on('click', politicaInput, function (e) {
            if (!privacidad) {
                e.preventDefault();
                modalPrivacidad();
    
                //return;
            }
    
            toggleChecks(false);
        });
    
        /**
         * Los clicks en el label de la política de privacidad abren el modal.
         */
        jQuery(document).on('click', politicaSpan, function (e) {
            if (!privacidad) {
                e.preventDefault();
                modalPrivacidad();
            }
        });
    
        /**
         * Acciones a realizar sí se reinicia el formulario.
         */
        jQuery(politicaInput).closest('form').on('reset', function (event) {
            setTimeout(function () {
                privacidad = jQuery(politicaInput).prop('checked');
            }, 1);
        });
    
        /**
         * Mostrar modal para la privacidad.
         */
        function modalPrivacidad() {
            jQuerymodal.veissModal({
                id: 'pol',
                buttons: [{
                    id: 'polnook',
                    class: 'btn btn-default modal-clear',
                    click: function () {
                        toggleChecks(false);
                    }
                }, {
                    id: 'polok',
                    class: 'btn btn-primary btn-serserve-on',
                    click: function () {
                        toggleChecks(true);
                    }
                }]
            });
        }
    
        /**
         * Cambiar el valor de la propiedad checked.
         */
        function toggleChecks(value) {
            privacidad = value;
            jQuery(politicaInput).prop('checked', value);
        }
    
        //Title Image
        jQuery('img').removeAttr('title');
    
    });

